var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rootAdmin",attrs:{"id":"rootAdmin"}},[(_vm.showAdminHeader)?_c('admin-header'):_vm._e(),(this.$route.name !== 'adminNotFound')?_c('router-view'):_vm._e(),_c('notification-center',{staticClass:"adminNotificationCenter"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }